import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@apollo/client";

import { valetLotSearch } from "./queries";
import { mapSessionToArrival } from "../helpers";

export const MIN_QUERY_LENGTH = 2;
export const MAX_RESULTS = 8;
const DEBOUNCE_MS = 250;

export default function useLotSearch(facilityId, term) {
  const trimmed = (term ?? "").trim();
  const [debounced, setDebounced] = useState(trimmed);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(trimmed), DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [trimmed]);

  const active = debounced.length >= MIN_QUERY_LENGTH;

  const { data, loading, error } = useQuery(valetLotSearch, {
    variables: { facilityId, search: debounced, limit: MAX_RESULTS },
    skip: !facilityId || !active,
    fetchPolicy: "cache-and-network",
  });

  const rawItems = active ? data?.valetSessions?.items : null;

  const items = useMemo(
    () => (rawItems ?? []).filter(Boolean).map(mapSessionToArrival),
    [rawItems],
  );

  return {
    items,
    count: active ? data?.valetSessions?.count ?? 0 : 0,
    loading:
      (loading && !rawItems) ||
      (trimmed.length >= MIN_QUERY_LENGTH && trimmed !== debounced),
    error,
    query: debounced,
    active,
  };
}
